export const CHANNEL_LABELS = {
  messenger: "Facebook Messenger",
  instagram: "Instagram DM",
  whatsapp: "WhatsApp",
  slack: "Slack",
  facebook: "Facebook Messenger",
};

export const CONNECTABLE_CHANNELS = [
  {
    id: "messenger",
    label: CHANNEL_LABELS.messenger,
    oauthPlatform: "facebook",
    description: "Connect a Facebook page and sync Messenger conversations into the CRM inbox.",
  },
  {
    id: "instagram",
    label: CHANNEL_LABELS.instagram,
    oauthPlatform: "instagram",
    description: "Connect Instagram and route DMs through the same CRM sync path.",
  },
];

export const getChannelLabel = (platform) => {
  if (!platform) return "Connected Messaging";
  return CHANNEL_LABELS[platform] || platform.replace(/[_-]+/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
};
